import { render, staticRenderFns } from "./DownloadTop.vue?vue&type=template&id=6b2e6ee4&"
import script from "./DownloadTop.vue?vue&type=script&lang=js&"
export * from "./DownloadTop.vue?vue&type=script&lang=js&"
import style0 from "./DownloadTop.vue?vue&type=style&index=0&id=6b2e6ee4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports